import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ConsumerInfo from '@/pages/consumer-info/ConsumerInfo.vue';

export default {
  path: '/consumer/user/:userToken',
  name: 'ConsumerInfo',
  components: {
    mainContent: ConsumerInfo,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'consumer-info',
    },
    breadcrumb: {
      title: 'Detalhes do Cliente',
      paths: [{ title: 'Cliente' }],
    },
  },
};
